import React from "react";
import { connect } from "react-redux";
import { Segment, Message } from "semantic-ui-react";

const PaginaNoEncontrada = props => {
  return (
    <Segment textAlign="center">
      <Message negative>
        <h1 className="md-display-4">404</h1>
        <h2 className="md-display-2">Página no encontrada</h2>
      </Message>
    </Segment>
  );
};

const mapStateToProps = state => {
  return {
    user: state.session.user
  };
};

export default connect(mapStateToProps)(PaginaNoEncontrada);



// WEBPACK FOOTER //
// ./src/pages/PaginaNoEncontrada.jsx